<template>
  <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Timeline</h1>
  <ol class="border-l border-gray-300 w-full md:w-1/2 md:ml-auto">
    <li v-for="(timeline, index) in this.timelines()" class="w-full" :class="{'ml-0 md:ml-[-100%]': odd(index)}">
      <div class="flex flex-start items-center pt-3" :class="{'flex-row md:flex-row-reverse': odd(index)}">
        <span class="flex h-2 w-2 relative" :class="{'-ml-1 mr-3': !odd(index), '-ml-1 mr-3 md:-mr-1 md:ml-3': odd(index)}">
          <span class="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-blue-400 opacity-75"></span>
          <span class="relative rounded-full h-2 w-2 bg-blue-600 text-white text-center"></span>
        </span>
        <p class="text-gray-500 text-sm">{{ this.$filters.formatDateTime(timeline.date) }}</p>
      </div>
      <div class="mt-0.5 mb-6 ml-4 text-left" :class="{'md:ml-0 md:text-right md:mr-4': odd(index)}">
        <h4 class="text-gray-800 font-semibold text-xl mb-1.5">{{ timeline.title }}</h4>
        <p class="text-gray-500 mb-3">{{ timeline.description }}</p>
      </div>
    </li>
  </ol>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  inject: ['patient', 'timelines'],
  components: {

  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {

    }
  },
  methods: {
    odd(n) {
      return n % 2;
    }
  },
}
</script>